import { render } from "./VendorPayAmount.vue?vue&type=template&id=67f35670"
import script from "./VendorPayAmount.vue?vue&type=script&lang=js"
export * from "./VendorPayAmount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__